export default "__VITE_ASSET__Cz_Atmlf__"